// key, title, img, content
const information = [];

export default information;
